import { createSlice } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { MainFilters } from '../../types/state';

const initialState: MainFilters = {
  data: [],
  fetchingStatusFilters: false,
  error: null
};

export const filtersMain = createSlice({
  name: NameSpace.FiltersMain,
  initialState,
  reducers: {
    fetchFiltersRequest: (state) => {
      state.fetchingStatusFilters = true;
      state.error = null;
    },
    fetchFiltersSuccess: (state, action) => {
      state.fetchingStatusFilters = false;
      state.data = action.payload;
    },
    fetchFiltersFailure: (state, action) => {
      state.fetchingStatusFilters = false;
      state.error = action.payload;
    },
  },
});

export const { fetchFiltersRequest, fetchFiltersSuccess, fetchFiltersFailure } = filtersMain.actions;
